const apiEndpointUrl =
  process.env.REACT_APP_API_ENDPOINT_URL || 
  process.env.API_ENDPOINT_URL ||
  'https://api.buyuksoylufilo.com/';//'http://195.244.63.75:3808/'

const dev = {
  API_ENDPOINT_URL: apiEndpointUrl
};

const prod = {
  API_ENDPOINT_URL: apiEndpointUrl
};

const test = {
  API_ENDPOINT_URL: apiEndpointUrl
};

const getEnv = () => {
  switch (process.env.NODE_ENV) {
    case "development":
      return dev;
    case "production":
      return prod;
    case "test":
      return test;
    default:
      break;
  }
};

export const env = getEnv();